import { useState } from "react";
import { Contacto } from "../../types/empresa";
import { EmpresaContactos } from "./EmpresaContactos";
import { EditContactoInfo } from "./EditContactoInfo";
import { CreateContactoInfo } from "./CreateContactoInfo";
import AddRoundedIcon from '@mui/icons-material/AddRounded';

interface Props {
    empresaId: number;
    contactos?: Contacto[];
}

export function ContactoContainer({ contactos, empresaId }: Props) {
    const [showEdit, setShowEdit] = useState(false);
    const [showCreate, setShowCreate] = useState(false);
    const [contacto, setContacto] = useState<Contacto | null>(null);
    const [showOverflow, setShowOverflow] = useState(false);

    if(showEdit && contacto !== null)
        return (
            <div>
                <EditContactoInfo 
                    empresaId={empresaId}
                    setShowEdit={setShowEdit}
                    showEdit={showEdit}
                    contacto={contacto}/>
            </div>
        );

    if(showCreate)
        return (
            <CreateContactoInfo
                empresaId={empresaId}
                setShowCreate={setShowCreate}
                showCreate={showCreate}/>
        );

    return (
        <div className="h-full overflow-y-auto">

            <button 
                className="bg-green-800 w-[90px] rounded px-[3px] py-[3px] flex gap-1 items-center justify-center"
                onClick={() => setShowCreate(true)}>
                <AddRoundedIcon sx={{ height: 15, width: 15, color: "white" }}/>
                <p className="text-white text-[13px] font-semibold">Contacto</p>
            </button>

            <div
                className="my-3"
                onMouseEnter={() => setShowOverflow(true)}
                onMouseLeave={() => setShowOverflow(false)}>
                
                <div className={`${showOverflow ? "overflow-auto" : "overflow-hidden"} max-h-[450px] transition-all duration-300`}>
                    {contactos?.length == 0
                    ? <div>
                        <p className="text-lg font-bold text-center">Sin contactos registrados</p>
                    </div>
                    : contactos?.map((contacto, index) => (
                        <>
                        {index === 0 ? (<div className="border my-2"></div>) : <></>}
                        <EmpresaContactos 
                            key={index}
                            setShowEdit={setShowEdit}
                            setContacto={setContacto}
                            showEdit={showEdit}
                            contacto={contacto}/>

                        <div className="border my-2"></div>
                        </>
                    ))}
                </div>
            </div>
        </div>
    );
}